/* YoxYox: Amazon-style keyword predictive + recent (X ile silmek) */
(() => {
  const input = document.getElementById('yoxyoxSearchInput');
  const suggest = document.getElementById('yoxyoxSuggest');
  if (!input || !suggest) return;

  const form = input.closest('form');
  const searchAction = (form && form.getAttribute('action')) || '/search';

  const SUGGEST_ENDPOINT = '/search/suggest.json';
  const RECENT_KEY = 'yoxyox_recent_searches_v2';
  const TREND_KEY = 'yoxyox_trending_searches_v1';

  const MAX_RECENT = 6;         // son 6 axtarış
  const MAX_SUGGEST = 6;        // keyword setirləri (see-all ayrıca əlavə olunur)
  const MAX_TREND_STORE = 80;   // local "database" max term

  // Default (manual) populyar axtarışlar (Hybrid üçün fallback)
  const POPULAR_TERMS = [
    'phone holder',
    'car vacuum',
    'wireless charger',
    'kitchen organizer',
    'pet brush',
    'led lights',
  ];

  const escapeHtml = (str) =>
    String(str).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m]));

  const normalize = (s) => String(s || '').trim();
  const lower = (s) => normalize(s).toLowerCase();

  const makeSearchUrl = (q) => {
    const params = new URLSearchParams();
    params.set('type', 'product');
    params.set('q', q);
    return `${searchAction}?${params.toString()}`;
  };

  const highlightLabel = (label, q) => {
    const text = String(label || '');
    const query = normalize(q);
    if (!query) return escapeHtml(text);

    const idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx < 0) return escapeHtml(text);

    const before = text.slice(0, idx);
    const match = text.slice(idx, idx + query.length);
    const after = text.slice(idx + query.length);

    return `${escapeHtml(before)}<span class="yoxyox-suggest-match">${escapeHtml(match)}</span>${escapeHtml(after)}`;
  };

  const getRecent = () => {
    try {
      const arr = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  };

  const setRecent = (arr) => {
    localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, MAX_RECENT)));
  };

  const saveRecent = (q) => {
    const term = normalize(q);
    if (!term) return;
    const list = getRecent().filter((x) => lower(x) !== lower(term));
    list.unshift(term);
    setRecent(list);
  };

  const removeRecent = (q) => {
    const term = lower(q);
    const list = getRecent().filter((x) => lower(x) !== term);
    setRecent(list);
  };

  const hide = () => {
    suggest.hidden = true;
    suggest.innerHTML = '';
    activeIndex = -1;
  };

  const show = () => {
    suggest.hidden = false;
  };

  // Keyboard state
  let activeIndex = -1;

  /* =========================
     Hybrid popular: local "database" (trending)
     ========================= */
  const getTrendMap = () => {
    try {
      const obj = JSON.parse(localStorage.getItem(TREND_KEY) || '{}');
      return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};
    } catch {
      return {};
    }
  };

  const setTrendMap = (obj) => {
    try {
      localStorage.setItem(TREND_KEY, JSON.stringify(obj));
    } catch {
      /* ignore */
    }
  };

  const saveTrend = (q) => {
    const term = normalize(q);
    if (!term) return;

    const key = lower(term);
    const now = Date.now();
    const map = getTrendMap();

    const prev = map[key];
    map[key] = {
      t: term,
      c: (prev?.c || 0) + 1,
      last: now,
    };

    // keep size under MAX_TREND_STORE
    const entries = Object.entries(map)
      .map(([k, v]) => ({ k, v }))
      .sort((a, b) => (b.v.last || 0) - (a.v.last || 0));

    const trimmed = entries.slice(0, MAX_TREND_STORE);
    const next = {};
    for (const e of trimmed) next[e.k] = e.v;
    setTrendMap(next);
  };

  const getTrending = () => {
    const map = getTrendMap();
    const arr = Object.values(map)
      .filter((v) => v && v.t)
      .sort((a, b) => {
        // score: count desc, then recency
        const dc = (b.c || 0) - (a.c || 0);
        if (dc) return dc;
        return (b.last || 0) - (a.last || 0);
      })
      .map((v) => v.t);

    // unique, stable
    const out = [];
    const seen = new Set();
    for (const t of arr) {
      const k = lower(t);
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(t);
    }
    return out;
  };

  const publishShopifySearchEvent = (term, source) => {
    try {
      // If Shopify Customer Events is available, this helps you see global search terms via analytics/pixels.
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('yoxyox_search', {
          term,
          source,
          ts: Date.now(),
        });
      }
    } catch {
      /* ignore */
    }
  };

  const logSearch = (q, source = 'submit') => {
    const term = normalize(q);
    if (!term) return;
    saveRecent(term);
    saveTrend(term);
    publishShopifySearchEvent(term, source);
  };

  const getLinks = () => Array.from(suggest.querySelectorAll('.yoxyox-suggest-link'));
  const setActive = (idx) => {
    const links = getLinks();
    if (!links.length) {
      activeIndex = -1;
      return;
    }

    // clamp
    const next = Math.max(0, Math.min(idx, links.length - 1));
    activeIndex = next;

    // remove old
    suggest.querySelectorAll('.yoxyox-suggest-item.is-active').forEach((el) => el.classList.remove('is-active'));

    const link = links[next];
    const item = link.closest('.yoxyox-suggest-item');
    if (item) item.classList.add('is-active');

    // make sure visible
    const list = suggest.querySelector('.yoxyox-suggest-list');
    if (list && item) {
      const itemRect = item.getBoundingClientRect();
      const listRect = list.getBoundingClientRect();
      if (itemRect.top < listRect.top) item.scrollIntoView({ block: 'nearest' });
      if (itemRect.bottom > listRect.bottom) item.scrollIntoView({ block: 'nearest' });
    }
  };

  const renderPanel = ({ title, items, highlightQ }) => {
    if (!items.length) return hide();

    const head = title
      ? `<div class="yoxyox-suggest-head">${escapeHtml(title)}</div>`
      : '';

    const lis = items
      .map((it) => {
        const type = it.type || 'query';

        if (type === 'divider') {
          return `<li class="yoxyox-suggest-divider">${escapeHtml(it.label || '')}</li>`;
        }

        const q = it.q;

        const icon =
          type === 'recent' ? '🕘' :
          type === 'popular' ? '🔥' :
          type === 'default' ? '⭐' :
          type === 'all' ? '↩' :
          '🔎';

        const labelHtml = highlightQ ? highlightLabel(it.label, highlightQ) : escapeHtml(it.label);
        const removable = !!it.removable;

        return `
          <li class="yoxyox-suggest-item yoxyox-suggest-item--${escapeHtml(type)}">
            <div class="yoxyox-suggest-row">
              <a class="yoxyox-suggest-link" data-q="${escapeHtml(q)}" href="${makeSearchUrl(q)}">
                <span class="yoxyox-suggest-ico">${icon}</span>
                <span class="yoxyox-suggest-text">${labelHtml}</span>
              </a>
              ${
                removable
                  ? `<button type="button" class="yoxyox-suggest-remove" data-q="${escapeHtml(q)}" aria-label="Sil">✕</button>`
                  : ``
              }
            </div>
          </li>
        `;
      })
      .join('');

    suggest.innerHTML = `
      <div class="yoxyox-suggest-panel" role="listbox" aria-label="Axtarış təklifləri">
        ${head}
        <ul class="yoxyox-suggest-list">${lis}</ul>
      </div>
    `;
    show();
    activeIndex = -1;
  };

  const renderRecentOrPopular = () => {
    const recent = getRecent().slice(0, MAX_RECENT);

    if (recent.length) {
      const items = [
        ...recent.map((t) => ({ type: 'recent', q: t, label: t, removable: true })),
      ];
      renderPanel({
        title: 'Son axtarışlar',
        highlightQ: null,
        items,
      });
      return;
    }

    // Populyar axtarışlar müvəqqəti gizlədildi — real trending data olmayanda göstərmə
    hide();
  };

  let timer = null;
  let controller = null;

  const fetchSuggestions = async (q) => {
    const url =
      `${SUGGEST_ENDPOINT}?q=${encodeURIComponent(q)}` +
      `&resources[type]=query&resources[type]=product&resources[limit]=10` +
      `&resources[options][unavailable_products]=show`;

    controller?.abort();
    controller = new AbortController();

    const res = await fetch(url, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });

    if (!res.ok) return { queries: [], products: [] };
    const data = await res.json();

    return {
      queries: data?.resources?.results?.queries || [],
      products: data?.resources?.results?.products || [],
    };
  };

  const buildItems = (q, queries, products) => {
    const items = [];
    const seen = new Set();

    const pushUnique = (text) => {
      const t = normalize(text);
      if (!t) return;
      const key = t.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      items.push({ type: 'query', q: t, label: t });
    };

    // 1) query suggestions
    for (const qu of queries) {
      pushUnique(qu?.text);
      if (items.length >= MAX_SUGGEST) break;
    }

    // 2) fallback: product titles as keywords
    if (items.length < MAX_SUGGEST) {
      for (const p of products) {
        pushUnique(p?.title);
        if (items.length >= MAX_SUGGEST) break;
      }
    }

    // If nothing returned, at least show the raw q as first suggestion
    if (!items.length) {
      items.push({ type: 'query', q, label: q });
    }

    // 3) "See all results" row (always)
    items.push({ type: 'all', q, label: `"${q}" üçün bütün nəticələrə bax` });

    return items;
  };

  const onInput = async () => {
    const q = normalize(input.value);

    if (!q) return renderRecentOrPopular();
    if (q.length < 2) return hide();

    try {
      const { queries, products } = await fetchSuggestions(q);
      const items = buildItems(q, queries, products);

      renderPanel({
        title: null,
        showRemove: false,
        highlightQ: q,
        items,
      });
    } catch {
      hide();
    }
  };

  // submit olanda log et (recent + trending + analytics)
  form?.addEventListener('submit', () => logSearch(input.value, 'submit'));

  // focus olanda bosdursa recent/popular goster
  input.addEventListener('focus', () => {
    if (!normalize(input.value)) renderRecentOrPopular();
  });

  // typing
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(onInput, 150);
  });

  // keyboard: arrows + enter + esc
  input.addEventListener('keydown', (e) => {
    const isOpen = !suggest.hidden;

    if (e.key === 'Escape') {
      hide();
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!isOpen) {
        onInput();
        return;
      }
      setActive(activeIndex + 1);
      return;
    }

    if (e.key === 'ArrowUp') {
      if (!isOpen) return;
      e.preventDefault();
      setActive(activeIndex - 1);
      return;
    }

    if (e.key === 'Enter') {
      if (!isOpen) return; // normal submit
      const links = getLinks();
      if (activeIndex >= 0 && links[activeIndex]) {
        e.preventDefault();
        const link = links[activeIndex];
        const q = link.getAttribute('data-q') || '';
        logSearch(q, 'keyboard');
        window.location.href = link.href;
      }
    }
  });

  // hover => active
  suggest.addEventListener('mousemove', (e) => {
    const link = e.target.closest('.yoxyox-suggest-link');
    if (!link) return;
    const links = getLinks();
    const idx = links.indexOf(link);
    if (idx >= 0) setActive(idx);
  });

  // dropdown click handling (event delegation)
  suggest.addEventListener('click', (e) => {
    const btn = e.target.closest('.yoxyox-suggest-remove');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const q = btn.getAttribute('data-q') || '';
      removeRecent(q);
      renderRecentOrPopular();
      return;
    }

    const link = e.target.closest('.yoxyox-suggest-link');
    if (link) {
      const q = link.getAttribute('data-q') || '';
      logSearch(q, 'suggest');
      // navigation özü olacaq (href)
    }
  });

  // kenara klik baglasin
  document.addEventListener('click', (e) => {
    if (e.target === input) return;
    if (suggest.contains(e.target)) return;
    hide();
  });

  /* ========================================
     MOBILE FULLSCREEN SEARCH OVERLAY
     Amazon-style: tap search → fullscreen
     ======================================== */
  const isMobile = () => window.innerWidth < 990;

  const overlay   = document.getElementById('yxMobileSearch');
  const mInput    = document.getElementById('yxMobileSearchInput');
  const mResults  = document.getElementById('yxMobileSearchResults');
  const mBack     = document.getElementById('yxMobileSearchBack');
  const mForm     = document.getElementById('yxMobileSearchForm');

  if (overlay && mInput && mResults && mBack) {
    let scrollY = 0;

    const openOverlay = () => {
      scrollY = window.pageYOffset;
      document.body.classList.add('yx-msearch-open');
      document.body.style.top = `-${scrollY}px`;
      overlay.hidden = false;
      mInput.value = '';
      mInput.focus();
      renderMobileRecentOrPopular();
    };

    const closeOverlay = () => {
      overlay.hidden = true;
      mResults.innerHTML = '';
      document.body.classList.remove('yx-msearch-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    };

    /* Intercept focus on desktop search input → open mobile overlay instead */
    input.addEventListener('focus', (e) => {
      if (isMobile()) {
        e.preventDefault();
        input.blur();
        openOverlay();
      }
    });

    /* Also intercept tap/click on mobile */
    input.addEventListener('click', (e) => {
      if (isMobile()) {
        e.preventDefault();
        input.blur();
        openOverlay();
      }
    });

    mBack.addEventListener('click', closeOverlay);

    /* Render helpers for mobile overlay */
    const escM = (str) => String(str).replace(/[&<>"']/g, (m) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));

    const highlightM = (label, q) => {
      const text = String(label || '');
      const query = normalize(q);
      if (!query) return escM(text);
      const idx = text.toLowerCase().indexOf(query.toLowerCase());
      if (idx < 0) return escM(text);
      const before = text.slice(0, idx);
      const match  = text.slice(idx, idx + query.length);
      const after  = text.slice(idx + query.length);
      return `${escM(before)}<span class="yx-msr-match">${escM(match)}</span>${escM(after)}`;
    };

    const renderMobilePanel = (items, highlightQ) => {
      if (!items.length) { mResults.innerHTML = ''; return; }

      const html = items.map((it) => {
        if (it.type === 'divider') {
          return `<div class="yx-msr-divider">${escM(it.label)}</div>`;
        }

        const ico = it.type === 'recent' ? '🕘' :
                    it.type === 'popular' ? '🔥' :
                    it.type === 'default' ? '⭐' :
                    it.type === 'all' ? '↩' : '🔎';

        const labelHtml = highlightQ ? highlightM(it.label, highlightQ) : escM(it.label);

        return `
          <div class="yx-msr-row ${it.type === 'all' ? 'yx-msr-all' : ''} ${it.type === 'popular' ? 'yx-msr-popular' : ''}">
            <a class="yx-msr-link" href="${makeSearchUrl(it.q)}" data-q="${escM(it.q)}">
              <span class="yx-msr-ico">${ico}</span>
              <span class="yx-msr-text">${labelHtml}</span>
            </a>
            ${it.removable ? `<button type="button" class="yx-msr-remove" data-q="${escM(it.q)}">✕</button>` : ''}
          </div>`;
      }).join('');

      mResults.innerHTML = html;
    };

    const renderMobileRecentOrPopular = () => {
      const recent = getRecent().slice(0, MAX_RECENT);

      if (recent.length) {
        const items = [
          { type: 'divider', label: 'Son axtarışlar' },
          ...recent.map((t) => ({ type: 'recent', q: t, label: t, removable: true })),
        ];
        renderMobilePanel(items, null);
        return;
      }

      // Populyar axtarışlar müvəqqəti gizlədildi — real trending data olmayanda göstərmə
      mResults.innerHTML = '';
    };

    /* Mobile input typing */
    let mTimer = null;
    let mController = null;

    const mOnInput = async () => {
      const q = normalize(mInput.value);
      if (!q) return renderMobileRecentOrPopular();
      if (q.length < 2) { mResults.innerHTML = ''; return; }

      try {
        const url =
          `${SUGGEST_ENDPOINT}?q=${encodeURIComponent(q)}` +
          `&resources[type]=query&resources[type]=product&resources[limit]=10` +
          `&resources[options][unavailable_products]=show`;

        mController?.abort();
        mController = new AbortController();
        const res = await fetch(url, { signal: mController.signal, headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const data = await res.json();
        const queries = data?.resources?.results?.queries || [];
        const products = data?.resources?.results?.products || [];

        const items = buildItems(q, queries, products);
        renderMobilePanel(items, q);
      } catch { /* ignore abort */ }
    };

    mInput.addEventListener('input', () => {
      clearTimeout(mTimer);
      mTimer = setTimeout(mOnInput, 150);
    });

    /* Mobile form submit */
    mForm.addEventListener('submit', () => {
      logSearch(mInput.value, 'mobile-submit');
    });

    /* Click handling inside results */
    mResults.addEventListener('click', (e) => {
      const rmBtn = e.target.closest('.yx-msr-remove');
      if (rmBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeRecent(rmBtn.getAttribute('data-q') || '');
        renderMobileRecentOrPopular();
        return;
      }

      const link = e.target.closest('.yx-msr-link');
      if (link) {
        logSearch(link.getAttribute('data-q') || '', 'mobile-suggest');
      }
    });

    /* Handle back button (browser) */
    window.addEventListener('popstate', () => {
      if (!overlay.hidden) closeOverlay();
    });
  }

})();
